import type { IRequestForInputs, IRequestForOutputs } from "@halliday-lib/api";

export const getQueryParamsFromAssetFilters = (filters: IRequestForInputs | IRequestForOutputs): string => {
    return Object.entries(filters)
        .reduce((acc, [key, value]) => {
            if (key === "sandbox") {
                acc.push(`sandbox=${value === true ? "true" : "false"}`);
            } else if (Array.isArray(value)) {
                for (const valueItem of value) {
                    acc.push(`${key}[]=${valueItem}`);
                }
            } else {
                acc.push(`${key}=${value}`);
            }
            return acc;
        }, [] as string[])
        .join("&");
};
